import { SetCourseExpandCollapse } from '../../../data-grid-container/courses/types/courses.types';
import {
    TransformCourse,
    TransformCourseTopics
} from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

type ManageCourseIsExpanded = {
    course: TransformCourse
    payload: SetCourseExpandCollapse
};

type ManageCourseExpandCollapse = {
    course: TransformCourse
    isExpanded: boolean
};

export function manageCollapseStrandChildTopics (strand: TransformCourseTopics, isExpanded: boolean) {
    return {
        ...strand,
        topics: strand.topics?.map((topic) => {
            return {
                ...topic,
                isExpanded
            };
        }) || null,
        isExpanded
    };
}

export function manageCourseStrandIsExpanded ({
    course,
    payload
}: ManageCourseIsExpanded) {
    const {
        strandId,
        topicId,
        isExpanded
    } = payload;

    return course.topics.map((strand) => {
        if (strand.id === strandId) {
            if (topicId) {
                const updatedTopics = strand.topics?.map((topic) =>
                    topic.id === topicId ? {
                        ...topic,
                        isExpanded
                    } : topic
                ) || null;

                return {
                    ...strand,
                    topics: updatedTopics
                };
            } else {
                if (!isExpanded) strand = manageCollapseStrandChildTopics(strand, isExpanded);

                return {
                    ...strand,
                    isExpanded
                };
            }
        }

        return strand;
    });
}

export function manageCourseTopicIsExpanded ({
    course,
    payload
}: ManageCourseIsExpanded) {
    return course.topics.map((topic) => {
        if (topic.id === payload.topicId) {
            return {
                ...topic,
                isExpanded: payload.isExpanded
            };
        }

        return topic;
    });
}

export function manageCourseTopicExpandCollapse ({
    course,
    isExpanded
}: ManageCourseExpandCollapse): TransformCourse {
    if (!course) return course;

    const isStrand = course.topics !== null;

    if (isStrand) {
        return {
            ...course,
            topics: course.topics?.map(topic => ({
                ...topic,
                isExpanded,
                topics: topic.topics?.map(subTopic => ({
                    ...subTopic,
                    isExpanded
                })) || null
            }))
        };
    }

    return course;
}

export function manageCourseTopicExpandCollapseCheck ({
    course,
    isExpanded
}: ManageCourseExpandCollapse) {
    const isStrand = course.topics !== null;

    if (course) {
        if (isStrand) return course.topics.every((strand) => strand.topics?.every((topic) => topic.isExpanded === !isExpanded));

        return course.topics.every((topic) => topic.isExpanded === !isExpanded);
    }

    return isExpanded;
}

export function manageStrandExpandCollapseIconClick ({
    course,
    isExpanded
}: ManageCourseExpandCollapse): TransformCourse {
    if (!course || !course.topics) return course;

    return {
        ...course,
        topics: course.topics.map((strand) => {
            if (isExpanded) {
                return manageCollapseStrandChildTopics(strand, isExpanded);
            } else {
                return {
                    ...strand,
                    topics: strand.topics?.map((topic) => ({
                        ...topic,
                        isExpanded: false
                    })) || null
                };
            }
        })
    };
}
